const {BASE_URL} = require('./client');

const GET_SCHOLARSHIPS = BASE_URL + '/api/scholarship/get';
module.exports = {
    GET_SCHOLARSHIPS
}